import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { CniAuditTable } from "@/features/cni-audit/components/CniAuditTable"

// Derin link: /cni/audit?entityType=tariffs — tarife yönetimi "Değişim logları"nı bu
// filtreyle açar (cni-users'ın id/role kalıbı).
const searchSchema = z.object({
  entityType: z.string().optional(),
  action: z.string().optional(),
})

export const Route = createFileRoute("/_authed/cni/audit")({
  component: CniAuditPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function CniAuditPage() {
  const { t } = useTranslation("cni-audit")
  const { entityType, action } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4 shrink-0">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <CniAuditTable initialEntityType={entityType ?? null} initialAction={action ?? null} />
    </div>
  )
}
